import { defineStore, type StateTree } from 'pinia';

interface State extends StateTree {
  isStationInitialSetup: boolean;
  editPaymentInfo: boolean;
  editCashlessPay: boolean;
  editMealPlan: boolean;
}

export function useFinancialConfigStore(storeId = 'financialConfig') {
  const store = defineStore(storeId, {
    state: (): State => ({
      isStationInitialSetup: false,
      editPaymentInfo: false,
      editCashlessPay: false,
      editMealPlan: false,
    }),
    actions: {},
    pagination: false,
  });

  return store();
}
